import { render } from "./Feed.vue?vue&type=template&id=0a6ecc6e"
import script from "./Feed.vue?vue&type=script&lang=js"
export * from "./Feed.vue?vue&type=script&lang=js"
script.render = render

export default script